<template>
    <svg fill="#EA7EF0" height="20" viewBox="0 0 8 20" width="8" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.76 17.842l-.253 1.142c-.758.33-1.365.583-1.816.756-.452.174-.977.26-1.576.26-.918 0-1.633-.249-2.143-.742-.51-.496-.764-1.125-.764-1.887 0-.295.018-.598.057-.907.038-.31.1-.659.184-1.048l.949-3.709c.084-.355.156-.691.213-1.01a4.83 4.83 0 0 0 .087-.868c0-.474-.089-.805-.266-.991-.176-.186-.514-.28-1.014-.28-.245 0-.497.043-.754.127A9.838 9.838 0 0 0 0 8.926l.254-1.143c.621-.28 1.215-.519 1.783-.717a4.877 4.877 0 0 1 1.613-.3c.912 0 1.616.244 2.11.732.495.487.742 1.12.742 1.898 0 .161-.016.445-.05.85-.035.408-.098.78-.19 1.12l-.945 3.693c-.078.296-.147.635-.208 1.017-.062.38-.092.669-.092.863 0 .49.099.825.297 1.003.2.178.545.267 1.034.267.23 0 .49-.045.78-.133.29-.089.502-.166.632-.234zM8 2.336c0 .643-.22 1.193-.66 1.645-.44.453-.971.68-1.592.68a2.16 2.16 0 0 1-1.599-.68 2.262 2.262 0 0 1-.667-1.645c0-.643.223-1.193.667-1.65A2.15 2.15 0 0 1 5.75 0c.62 0 1.15.229 1.59.685.442.458.661 1.009.661 1.65z"
            fill-rule="nonzero"
        />
    </svg>
</template>
<script>
export default {
    name: "Info",
};
</script>
